import React, { useState } from 'react';
import { Card, CardBody, Row, Col, Button } from 'reactstrap';
import Select from 'react-select';
import { MdSearch } from 'react-icons/lib/md';
import { httpClient } from '../../../api/httpClient';
import { urlConsultarCedulaMotos } from '../api/urls';

const SpinnerCircular = () => (
    <svg
        style={{
            width: '16px',
            height: '16px',
            animation: 'spinMotos 0.75s linear infinite',
            display: 'inline-block',
            verticalAlign: 'middle'
        }}
        viewBox="0 0 24 24"
        fill="none"
    >
        <circle
            cx="12"
            cy="12"
            r="10"
            stroke="rgba(255, 255, 255, 0.3)"
            strokeWidth="3"
        />
        <path
            fill="#ffffff"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
    </svg>
);

const styles = {
    label: {
        fontSize: '15px',
        fontWeight: 'bold',
        color: '#000000',
        margin: 0
    }
};

const selectStyles = {
    menuPortal: base => ({ ...base, zIndex: 9999 })
};

const OPCIONES_TIPO_DOC = [
    { value: '1', label: 'Cédula de Identidad' },
    { value: '2', label: 'RUC' },
    { value: '3', label: 'Pasaporte' }
];

const OPCIONES_GENERO = [
    { value: '1', label: 'Masculino' },
    { value: '2', label: 'Femenino' }
];

const OPCIONES_ESTADO_CIVIL = [
    { value: '1', label: 'Soltero(a)' },
    { value: '2', label: 'Casado(a)' },
    { value: '4', label: 'Divorciado(a)' },
    { value: '3', label: 'Unión Libre' },
    { value: '5', label: 'Viudo(a)' }
];

/**
 * Card de Datos del Asegurado para Motos (1 elemento por renglón).
 */
const DatosAseguradoMoto = ({
    datosAsegurado,
    onChangeCampoAsegurado,
    errores
}) => {
    const [consultandoCedula, setConsultandoCedula] = useState(false);
    const [mensajeDinardap, setMensajeDinardap] = useState(null);

    var a = datosAsegurado || {};
    var err = errores || {};

    var tipoDoc = a.tipoDocumento || { value: '1', label: 'Cédula de Identidad' };
    if (tipoDoc && tipoDoc.value === 'CEDULA') {
        tipoDoc = { value: '1', label: 'Cédula de Identidad' };
    } else if (tipoDoc && tipoDoc.value === 'RUC') {
        tipoDoc = { value: '2', label: 'RUC' };
    } else if (tipoDoc && tipoDoc.value === 'PASAPORTE') {
        tipoDoc = { value: '3', label: 'Pasaporte' };
    }
    var identificacion = a.identificacion || '';
    var nombres = a.nombres || '';
    var fechaNacimiento = a.fechaNacimiento || '';
    var genero = a.genero || null;
    var estadoCivil = a.estadoCivil || null;
    var celular = a.celular || '';
    var correo = a.correo || '';
    var direccion = a.direccion || '';

    var handleConsultarCedula = async function(numIdent) {
        var doc = numIdent || identificacion;
        if (!doc || doc.length < 10) return;

        setConsultandoCedula(true);
        setMensajeDinardap(null);
        try {
            var res = await httpClient.get(urlConsultarCedulaMotos + doc);
            var dp = (res && res.datosPersona) || (res && (res.transaccion !== false || res.estadoTransaccion) ? res : null);
            
            if (dp && (dp.nombre || dp.nombres || dp.cedula || dp.primer_nombre || dp.nombre1)) {
                // 1. Nombres
                var nombreCompleto = dp.nombre || dp.nombres || ((dp.primer_nombre || dp.nombre1 || '') + ' ' + (dp.segundo_nombre || dp.nombre2 || '') + ' ' + (dp.primer_apellido || dp.apellido1 || '') + ' ' + (dp.segundo_apellido || dp.apellido2 || '')).trim();
                if (nombreCompleto && onChangeCampoAsegurado) {
                    onChangeCampoAsegurado('nombres', nombreCompleto.toUpperCase());
                }

                // 2. Fecha de Nacimiento
                var fechaNac = dp.fecha_nacimiento || dp.fechaNacimiento || dp.fechaNac || '';
                if (fechaNac && onChangeCampoAsegurado) {
                    if (fechaNac.indexOf('/') !== -1) {
                        var parts = fechaNac.split('/');
                        if (parts.length === 3) {
                            fechaNac = parts[2] + '-' + (parts[1].length === 1 ? '0' + parts[1] : parts[1]) + '-' + (parts[0].length === 1 ? '0' + parts[0] : parts[0]);
                        }
                    }
                    onChangeCampoAsegurado('fechaNacimiento', fechaNac);
                }

                // 3. Género
                var genRaw = dp.genero || dp.codigo_genero || '';
                if (genRaw && onChangeCampoAsegurado) {
                    var genStr = String(genRaw).toUpperCase();
                    var esMas = (genStr.indexOf('M') === 0 || genStr === '1');
                    onChangeCampoAsegurado('genero', { value: esMas ? '1' : '2', label: esMas ? 'Masculino' : 'Femenino' });
                }

                // 4. Estado Civil
                var ecRaw = dp.estado_civil || dp.estadoCivil || dp.codigo_estado_civil || '';
                if (ecRaw && onChangeCampoAsegurado) {
                    var ecVal = String(ecRaw).toUpperCase();
                    var matchEc = OPCIONES_ESTADO_CIVIL.find(function(op) {
                        return op.value === ecVal || 
                            (ecVal === 'SOLTERO' && op.value === '1') ||
                            (ecVal === 'CASADO' && op.value === '2') ||
                            (ecVal === 'DIVORCIADO' && op.value === '4') ||
                            (ecVal === 'UNION LIBRE' && op.value === '3') ||
                            (ecVal === 'VIUDO' && op.value === '5') ||
                            op.label.toUpperCase().indexOf(ecVal) !== -1 || 
                            ecVal.indexOf(op.value) !== -1;
                    });
                    if (matchEc) {
                        onChangeCampoAsegurado('estadoCivil', matchEc);
                    }
                }

                // 5. Celular
                var celRaw = dp.telefono_celular || dp.celular || dp.celulares || dp.telefono_domicilio || '';
                if (celRaw && onChangeCampoAsegurado) {
                    var celClean = String(celRaw).replace(/[^0-9]/g, '');
                    if (celClean) {
                        onChangeCampoAsegurado('celular', celClean.substring(0, 10));
                    }
                }

                // 6. Correo Electrónico
                var emailRaw = dp.email || dp.correo || '';
                if (emailRaw && onChangeCampoAsegurado) {
                    onChangeCampoAsegurado('correo', String(emailRaw).toLowerCase().trim());
                }

                // 7. Dirección
                var dirRaw = dp.direccion_domicilio || dp.direcciones || dp.direccion || dp.direccion_trabajo || '';
                if (dirRaw && onChangeCampoAsegurado) {
                    onChangeCampoAsegurado('direccion', String(dirRaw).toUpperCase().trim());
                }

                setMensajeDinardap({ tipo: 'success', texto: 'Información recuperada automáticamente.' });
            } else {
                setMensajeDinardap({ tipo: 'info', texto: 'No se encontró información automática. Complete los datos manualmente.' });
            }
        } catch (error) {
            setMensajeDinardap({ tipo: 'warning', texto: 'No fue posible consultar el servicio de identificación. Complete manualmente.' });
        } finally {
            setConsultandoCedula(false);
        }
    };

    return (
        <Card className="shadow-sm mb-4">
            <CardBody style={{ padding: '2rem' }}>
                <h4 style={{ fontWeight: 'bold', color: '#000000', marginBottom: '1.5rem' }}>
                    Datos del Asegurado
                </h4>

                {mensajeDinardap && (
                    <div className={"alert alert-" + mensajeDinardap.tipo + " py-2 mb-3"}>
                        <i className="fa fa-info-circle mr-2"></i> {mensajeDinardap.texto}
                    </div>
                )}

                {/* 1. Tipo de Documento */}
                <Row className="mb-3 align-items-center">
                    <Col lg={4} md={4} sm={12} className="mb-1 mb-md-0">
                        <h5 style={styles.label}>Tipo de documento(*)</h5>
                    </Col>
                    <Col lg={8} md={8} sm={12}>
                        <Select 
                            value={tipoDoc}
                            onChange={(val) => {
                                if (onChangeCampoAsegurado) onChangeCampoAsegurado('tipoDocumento', val);
                            }}
                            options={OPCIONES_TIPO_DOC}
                            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                            styles={selectStyles}
                        />
                    </Col>
                </Row>

                {/* 2. Cédula */}
                <Row className="mb-3 align-items-center">
                    <Col lg={4} md={4} sm={12} className="mb-1 mb-md-0">
                        <h5 style={styles.label}>Cédula</h5>
                    </Col>
                    <Col lg={8} md={8} sm={12}>
                        <div className="input-group">
                            <input 
                                type="text"
                                className={"form-control" + (err.identificacion ? " is-invalid" : "")}
                                placeholder="Ingrese la cédula del asegurado"
                                value={identificacion}
                                onChange={(e) => {
                                    var val = e.target.value.replace(/[^0-9A-Za-z]/g, '');
                                    if (onChangeCampoAsegurado) onChangeCampoAsegurado('identificacion', val);
                                    if (val.length === 10 && (tipoDoc.value === '1' || tipoDoc.value === '2' || tipoDoc.value === 'CEDULA' || tipoDoc.value === 'RUC')) {
                                        handleConsultarCedula(val);
                                    }
                                }}
                                maxLength={13}
                            />
                            <div className="input-group-append">
                                <Button 
                                    color="secondary" 
                                    onClick={() => handleConsultarCedula()}
                                    disabled={consultandoCedula || !identificacion}
                                    title="Consultar número de identificación"
                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: '42px' }}
                                >
                                    {consultandoCedula ? <SpinnerCircular /> : <MdSearch size={20} color="#ffffff" />}
                                </Button>
                            </div>
                            <style>{`
                                @keyframes spinMotos {
                                    0% { transform: rotate(0deg); }
                                    100% { transform: rotate(360deg); }
                                }
                            `}</style>
                        </div>
                        {err.identificacion && (
                            <span className="text-danger d-block mt-1" style={{ fontSize: '0.82rem', fontWeight: 'bold' }}>
                                <i className="fa fa-exclamation-circle mr-1"></i> Ingrese un número de identificación válido.
                            </span>
                        )}
                    </Col>
                </Row>

                {/* 3. Nombre */}
                <Row className="mb-3 align-items-center">
                    <Col lg={4} md={4} sm={12} className="mb-1 mb-md-0">
                        <h5 style={styles.label}>Nombre</h5>
                    </Col>
                    <Col lg={8} md={8} sm={12}>
                        <input 
                            type="text"
                            className={"form-control" + (err.nombres ? " is-invalid" : "")}
                            placeholder="Ingrese nombres completos o razón social"
                            value={nombres}
                            onChange={(e) => {
                                if (onChangeCampoAsegurado) onChangeCampoAsegurado('nombres', e.target.value.toUpperCase());
                            }}
                        />
                        {err.nombres && (
                            <span className="text-danger d-block mt-1" style={{ fontSize: '0.82rem', fontWeight: 'bold' }}>
                                <i className="fa fa-exclamation-circle mr-1"></i> Por favor ingrese nombres completos.
                            </span>
                        )}
                    </Col>
                </Row>

                {/* 4. Fecha de Nacimiento */}
                <Row className="mb-3 align-items-center">
                    <Col lg={4} md={4} sm={12} className="mb-1 mb-md-0">
                        <h5 style={styles.label}>Fecha de Nacimiento</h5>
                    </Col>
                    <Col lg={8} md={8} sm={12}>
                        <input 
                            type="date"
                            className={"form-control" + (err.fechaNacimiento ? " is-invalid" : "")}
                            value={fechaNacimiento}
                            onChange={(e) => {
                                if (onChangeCampoAsegurado) onChangeCampoAsegurado('fechaNacimiento', e.target.value);
                            }}
                        />
                        {err.fechaNacimiento && (
                            <span className="text-danger d-block mt-1" style={{ fontSize: '0.82rem', fontWeight: 'bold' }}>
                                <i className="fa fa-exclamation-circle mr-1"></i> {err.fechaNacimientoMsg || "Edad permitida: entre 18 y 70 años."}
                            </span>
                        )}
                    </Col>
                </Row>

                {/* 5. Género */}
                <Row className="mb-3 align-items-center">
                    <Col lg={4} md={4} sm={12} className="mb-1 mb-md-0">
                        <h5 style={styles.label}>Género</h5>
                    </Col>
                    <Col lg={8} md={8} sm={12}>
                        <Select 
                            value={genero}
                            onChange={(val) => {
                                if (onChangeCampoAsegurado) onChangeCampoAsegurado('genero', val);
                            }}
                            options={OPCIONES_GENERO}
                            placeholder="Seleccione género..."
                            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                            styles={selectStyles}
                        />
                        {err.genero && (
                            <span className="text-danger d-block mt-1" style={{ fontSize: '0.82rem', fontWeight: 'bold' }}>
                                <i className="fa fa-exclamation-circle mr-1"></i> Por favor seleccione el género.
                            </span>
                        )}
                    </Col>
                </Row>

                {/* 6. Estado Civil */}
                <Row className="mb-3 align-items-center">
                    <Col lg={4} md={4} sm={12} className="mb-1 mb-md-0">
                        <h5 style={styles.label}>Estado Civil</h5>
                    </Col>
                    <Col lg={8} md={8} sm={12}>
                        <Select 
                            value={estadoCivil}
                            onChange={(val) => {
                                if (onChangeCampoAsegurado) onChangeCampoAsegurado('estadoCivil', val);
                            }}
                            options={OPCIONES_ESTADO_CIVIL}
                            placeholder="Seleccione estado civil..."
                            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                            styles={selectStyles}
                        />
                        {err.estadoCivil && (
                            <span className="text-danger d-block mt-1" style={{ fontSize: '0.82rem', fontWeight: 'bold' }}>
                                <i className="fa fa-exclamation-circle mr-1"></i> Por favor seleccione el estado civil.
                            </span>
                        )}
                    </Col>
                </Row>

                {/* 7. Celular */}
                <Row className="mb-3 align-items-center">
                    <Col lg={4} md={4} sm={12} className="mb-1 mb-md-0">
                        <h5 style={styles.label}>Celular</h5>
                    </Col>
                    <Col lg={8} md={8} sm={12}>
                        <input 
                            type="tel"
                            className={"form-control" + (err.celular ? " is-invalid" : "")}
                            placeholder="Ej: 0998765432"
                            value={celular}
                            onChange={(e) => {
                                var val = e.target.value.replace(/[^0-9]/g, '');
                                if (onChangeCampoAsegurado) onChangeCampoAsegurado('celular', val);
                            }}
                            maxLength={10}
                        />
                        {err.celular && (
                            <span className="text-danger d-block mt-1" style={{ fontSize: '0.82rem', fontWeight: 'bold' }}>
                                <i className="fa fa-exclamation-circle mr-1"></i> Ingrese un número de celular de 10 dígitos.
                            </span>
                        )}
                    </Col>
                </Row>

                {/* 8. Correo */}
                <Row className="mb-3 align-items-center">
                    <Col lg={4} md={4} sm={12} className="mb-1 mb-md-0">
                        <h5 style={styles.label}>Correo Electrónico</h5>
                    </Col>
                    <Col lg={8} md={8} sm={12}>
                        <input 
                            type="email"
                            className={"form-control" + (err.correo ? " is-invalid" : "")}
                            placeholder="correo@ejemplo.com"
                            value={correo}
                            onChange={(e) => {
                                if (onChangeCampoAsegurado) onChangeCampoAsegurado('correo', e.target.value.toLowerCase().trim());
                            }}
                        />
                        {err.correo && (
                            <span className="text-danger d-block mt-1" style={{ fontSize: '0.82rem', fontWeight: 'bold' }}>
                                <i className="fa fa-exclamation-circle mr-1"></i> Ingrese un correo electrónico válido.
                            </span>
                        )}
                    </Col>
                </Row>

                {/* 9. Dirección */}
                <Row className="mb-2 align-items-center">
                    <Col lg={4} md={4} sm={12} className="mb-1 mb-md-0">
                        <h5 style={styles.label}>Dirección</h5>
                    </Col>
                    <Col lg={8} md={8} sm={12}>
                        <input 
                            type="text"
                            className={"form-control" + (err.direccion ? " is-invalid" : "")}
                            placeholder="Calle principal, secundaria y número"
                            value={direccion}
                            onChange={(e) => {
                                if (onChangeCampoAsegurado) onChangeCampoAsegurado('direccion', e.target.value.toUpperCase());
                            }}
                        />
                        {err.direccion && (
                            <span className="text-danger d-block mt-1" style={{ fontSize: '0.82rem', fontWeight: 'bold' }}>
                                <i className="fa fa-exclamation-circle mr-1"></i> Por favor ingrese la dirección.
                            </span>
                        )}
                    </Col>
                </Row>
            </CardBody>
        </Card>
    );
};

export default DatosAseguradoMoto;
